import MicroModal from "micromodal";

export default function triggerPopUp() {
  const isPresent = document.querySelector(".notification-modal");
  if (!isPresent) {
    return;
  }

  // Function to set a session cookie
    // function setSessionCookie(name, value) {
    //   document.cookie = `${name}=${value}`;
    // }

    // // Function to check if a cookie exists
    // function getCookie(name) {
    //   const cookies = document.cookie.split(';');
    //   for (let i = 0; i < cookies.length; i++) {
    //       let cookie = cookies[i].trim();
    //       if (cookie.startsWith(`${name}=`)) {
    //           return cookie.substring(name.length + 1);
    //       }
    //   }
    //   return null;
    // }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    // Main code
    window.addEventListener('load', () => {
      // Check if the 'modalShown' cookie is set
      if (!getCookie('modalShown')) {
        // Wait 1 second before showing the modal
        setTimeout(() => {
          // Initialize and show the modal
          MicroModal.show('notification-window', {
              onClose: function() {
                  // Set a session cookie when the modal is closed
                  // setSessionCookie('modalShown', 'true');
                  setCookie("modalShown", "yes", 1);
              }
          });
        }, 1000);
      }

      // Listen for clicks on elements with class '.popup-cta'
      const popupCTAs = document.querySelectorAll('.popup-cta');
      popupCTAs.forEach((element) => {
          element.addEventListener('click', () => {
              // Set the session cookie when the element is clicked
              // setSessionCookie('modalShown', 'true');
              setCookie("modalShown", "yes", 1);
          });
      });
    });
}
